import * as React from 'react';

import {reduxForm} from 'redux-form';

import {SidebarFormWrapper} from 'shells/form/sidebar-form-wrapper';

import {FORM_NAME} from './constants';
import type {MappingFormValues} from './types';

type Props = {
    title: string;
    subtitle: string;
    onClose: () => void;
    isSaving: boolean;
    isNewItem: boolean;
    children: React.ReactNode;
    deleteProps?: {
        onDelete: () => Promise<any>;
        buttonText?: string;
        title: string;
        message: string;
    };
    saveFailedErrorMessage: string | null | undefined;
    handleSubmit: (eventOrSubmit?: any) => undefined | Promise<any>;
    invalid: boolean;
    pristine: boolean;
    submitting: boolean;
};

function FieldMappingSidebarFormConnected(props: Props) {
    return <SidebarFormWrapper {...props} />;
}

function validate(formValues: MappingFormValues) {
    const errors: Record<string, any> = {};

    if (!formValues.selectedField && !formValues.isIgnored) {
        // We won't show this error anywhere, but we need it to disable the save button
        // if no field is selected and the field is not ignored
        errors.selectedField = 'Please select a field';
    }

    return errors;
}

export const FieldMappingSidebarForm = reduxForm({
    form: FORM_NAME,
    validate,
    destroyOnUnmount: true,
    enableReinitialize: true,
    // @ts-expect-error
})(FieldMappingSidebarFormConnected);
